var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBars = function SvgBars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.059 3.392c.135 0 .27-.046.36-.136.09-.09.18-.225.18-.406V1.408c0-.136-.09-.27-.18-.361-.09-.09-.225-.18-.36-.18H.94c-.18 0-.315.09-.405.18a.512.512 0 0 0-.136.36V2.85c0 .18.045.316.136.406.09.09.225.136.405.136H20.06Zm0 7.214c.135 0 .27-.046.36-.136.09-.09.18-.225.18-.405V8.622c0-.136-.09-.27-.18-.361-.09-.09-.225-.18-.36-.18H.94c-.18 0-.315.09-.405.18a.512.512 0 0 0-.136.36v1.444c0 .18.045.315.136.405.09.09.225.136.405.136H20.06Zm0 7.214c.135 0 .27-.045.36-.136.09-.09.18-.225.18-.405v-1.443c0-.136-.09-.27-.18-.36-.09-.091-.225-.181-.36-.181H.94c-.18 0-.315.09-.405.18a.512.512 0 0 0-.136.36v1.444c0 .18.045.315.136.405.09.09.225.136.405.136H20.06Z",
    fill: "#000"
  })));
};

export default SvgBars;